export type DateRangeProps = {
  dateRange?: [Date, Date];
  onDateRangeChange?: (newRange: [Date, Date]) => void;
};
